import { jsx as _jsx } from "react/jsx-runtime";
import { ExpansionTableRow } from '../ExpansionTableRow';
import { ExpansionTableRowCardWrapper } from '../ExpansionTableRowCardWrapper';
const cardContentSpacing = { spacing: '1' };
export const ExpansionTableHintRow = ({ columns, hasAllRowsExpanded, variant, tableHasDetail, backgroundColorOverride, }) => {
    return (_jsx(ExpansionTableRowCardWrapper, { cardVariant: variant, contentSpacing: cardContentSpacing, backgroundColorOverride: backgroundColorOverride, children: _jsx(ExpansionTableRow, { columns: columns, hasAllRowsExpanded: hasAllRowsExpanded, tableHasDetail: tableHasDetail, showIconPlaceholder: !tableHasDetail }) }));
};
